// extracted by mini-css-extract-plugin
export default {"h4":"Title_h4__zsrAj"};